import { render, staticRenderFns } from "./IconChevronUpAlt.vue?vue&type=template&id=9a5b61aa&"
import script from "./IconChevronUpAlt.vue?vue&type=script&lang=js&"
export * from "./IconChevronUpAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports